module.exports = __webpack_public_path__ + "static/media/icon.e26b4c37.png";